import { useMemo } from 'react'

import { getActiveChainId } from '@/config/active'

import { buildPoolsIdentitySeed } from '../poolsIdentitySeed'
import type { PoolIdentity } from '../types'

/**
 * Identidad de pools para operativa (swap/LP routing + policy).
 * Solo seed de product-config — la vitrina usa NutrimaticMarketHub.
 */
export function usePoolsIdentity(): {
  data: PoolIdentity[]
  isEnrichedFromApi: boolean
} {
  const chainId = getActiveChainId()
  const data = useMemo(() => buildPoolsIdentitySeed(chainId), [chainId])

  return {
    data,
    isEnrichedFromApi: false,
  }
}
